import { type GeoJsonFeature } from '~/_shared/types/polygon/polygon.types';
import {
  apiGet, apiPost,
} from '../_shared/utils/api/api.helpers';

export type Transportation = 'cycling' | 'driving' | 'driving+train' | 'public_transport' | 'walking' | 'coach' | 'bus' |
'train' | 'ferry' | 'driving+ferry' | 'cycling+ferry' | 'cycling+public_transport';

export type DriveTimeErrorResponseMessage =
  'TRAVEL_TIME_EMPTY_TERRITORIES' |
  'TRAVEL_TIME_INVALID_AREA' |
  'TRAVEL_TIME_INVALID_START' |
  'TRAVEL_TIME_API_FAILED' |
  'TRAVEL_TIME_OTHER' |
  'TRAVEL_TIME_LIMIT_REACHED';

type DriveTimeTimeMapServerModel = {
  list: ReadonlyArray<{
    id: string;
    longitude: number;
    latitude: number;
    travel_time: number;
    transportation: Transportation;
    no_holes?: boolean;
  }>;
};

export type DriveTimeTimeMapRequest = ReadonlyArray<{
  id: string;
  longitude: number;
  latitude: number;
  travel_time: number;
  transportation: Transportation;
  no_holes?: boolean;
}>;

export type DriveTimeRouteResponseSuccess = {
  success: true;
  data: ReadonlyArray<GeoJsonFeature>;
};

export type DriveTimeRouteResponseError = {
  success: false;
  message: DriveTimeErrorResponseMessage;
  data: undefined;
};

export type DriveTimeRouteResponseType = DriveTimeRouteResponseSuccess | DriveTimeRouteResponseError;

export type DriveTimeRouteStartResponse = Readonly<{ hash?: string; data?: ReadonlyArray<DriveTimeRouteResponseType> }>;
export type DriveTimeRouteResultsResponse = Readonly<{ data: ReadonlyArray<DriveTimeRouteResponseType> }>;

export const getDriveTimeRouteStart = (clientId: number, mapId: number | null, list: DriveTimeTimeMapRequest): Promise<DriveTimeRouteStartResponse> => {
  const requestUrl = `/api/clients/${clientId}/travel-time/time-map/async/start` + (mapId ? `?map_id=${mapId}` : '');
  const request: DriveTimeTimeMapServerModel = { list };

  return apiPost(requestUrl, request);
};

export const getDriveTimeRouteResults = (clientId: number, mapId: number | null, hash: string): Promise<DriveTimeRouteResultsResponse> => {
  const requestUrl = `/api/clients/${clientId}/travel-time/time-map/async/result/${hash}` + (mapId ? `?map_id=${mapId}` : '');

  return apiGet(requestUrl);
};
